import * as React from 'react';

import {SegmentedControl} from 'shells/card/segmented-control';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {DigestTypeEnum} from 'nutshell-graphql-types';

import {DIGEST_TYPE_OPTIONS} from './consts';

type Props = {
    selectedPreviewType: DigestTypeEnum;
    setSelectedPreviewType: (value: DigestTypeEnum) => void;
    isAdmin: boolean;
};

export function DigestPreviewHeader(props: Props) {
    return (
        <Stack isHorizontal={true} justifyContent='space-between' alignItems='center'>
            <Body isBold={true} size='large'>
                Preview using sample data
            </Body>
            {props.isAdmin && (
                <div className='half-width'>
                    <SegmentedControl
                        buttonOptions={DIGEST_TYPE_OPTIONS}
                        selectedValue={props.selectedPreviewType}
                        setSelectedValue={(newValue) => props.setSelectedPreviewType(newValue)}
                        hasPadding={false}
                        isAnimated={true}
                    />
                </div>
            )}
        </Stack>
    );
}
